const getContact = async e => {
  e.preventDefault();
  console.log(e);

  const mailLink = e.target;
  const link = new URL(mailLink.href);
  const type = link.hash.slice(1);

  const form = new FormData();
  form.append("action", "getcontact");
  form.append("type",type );
  const body = new URLSearchParams(form);

  const response = await fetch(loadmore_params.ajaxurl, {
    // you can also use $.post here
    method: "POST",
    credentials: "same-origin",
    headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded" }),
    body: body
    // headers: {
    //   'Content-Type': 'application/json;charset=utf-8'
    // },
    // body: body
  });

  const result = await response.text();

  if (response.status === 200) {
    mailLink.innerHTML = result;
    mailLink.href = 'mailto:' +result;
    mailLink.removeEventListener("click", getContact);

  }
};

export const cleanGetContact = () => {
  const loadmoreButtons = document.querySelectorAll(".show-contact");
  loadmoreButtons.forEach(loadmoreButton => {
    loadmoreButton.removeEventListener("click", getContact);
  });
};

export const initGetContact = () => {
  const loadmoreButtons = document.querySelectorAll(".show-contact");

  loadmoreButtons.forEach(loadmoreButton => {
    loadmoreButton.addEventListener("click", getContact);
  });
};
